import * as React from "react";
import {
  LoaderFunctionArgs,
  redirect,
  useNavigate,
  useParams,
  Outlet,
} from "react-router-dom";
import { useAccount } from "../../Account";
import { SupportedFunctionalityHolder } from "../../SupportedFunctionality";
import AccountGuardianSelector from "./AccountGuardianSelector";
import { Box } from "@mui/material";
import { useCallback } from "react";
import { useScrollToTop } from "@tlc/ui/ScrollToTop";

export async function loanHistoryLoader({ request }: LoaderFunctionArgs) {
  console.log("loanHistoryLoader executing");

  const supportedFunctionality = await SupportedFunctionalityHolder.get();

  if (supportedFunctionality.supportsLoanHistory === false) {
    return redirect("/myaccount/summary");
  }

  return {};
}

export const AccountHistoryPage: React.FC = () => {
  const { hasChildrenAndCanViewDependentLoansActivity } = useAccount();

  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();

  const handleSelectId = useCallback(
    (id?: string | null): void => {
      const path = id ? `/myaccount/history/child/${id}` : `/myaccount/history`;
      navigate(path);
    },
    [navigate],
  );

  const [scrollCallbackRef, scrollToTop] = useScrollToTop();

  return (
    <>
      <Box component="div" ref={scrollCallbackRef} tabIndex={-1} />
      {hasChildrenAndCanViewDependentLoansActivity && (
        <Box component="div" sx={{ p: 1 }}>
          <AccountGuardianSelector selectedId={id} onSelect={handleSelectId} />
        </Box>
      )}
      <Outlet context={{ scrollToTop }} />
    </>
  );
};
